var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 364,
    viewBox: "0 0 502 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_480_9133)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_9133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.7891,
    y: 44,
    width: 374.423,
    height: 236,
    rx: 9.07692,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7891 53.0769C63.7891 48.0639 67.8529 44 72.866 44H429.135C434.148 44 438.212 48.0639 438.212 53.0769V73.5H63.7891V53.0769Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 58.75H375.808",
    stroke: "white",
    strokeWidth: 1.70192,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.11,
    y: 55.0625,
    width: 7.375,
    height: 7.375,
    rx: 1.98558,
    stroke: "white",
    strokeWidth: 1.70192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.789 62.1539L424.597 55.3462M417.789 55.3462L424.597 62.1539",
    stroke: "white",
    strokeWidth: 1.70192,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 374.423,
    height: 40.8462,
    transform: "translate(63.7891 73.5)",
    fill: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9414,
    y: 88.25,
    width: 68.0769,
    height: 11.3462,
    rx: 4.53846,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.094,
    y: 88.25,
    width: 68.0769,
    height: 11.3462,
    rx: 4.53846,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.211,
    y: 88.25,
    width: 45.3846,
    height: 11.3462,
    rx: 4.53846,
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.672,
    y: 88.25,
    width: 45.3846,
    height: 11.3462,
    rx: 4.53846,
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7891 114.346H438.212V270.923C438.212 275.936 434.148 280 429.135 280H72.866C67.853 280 63.7891 275.936 63.7891 270.923V114.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 132.5,
    width: 34.0385,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 152.923,
    width: 41.9808,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 173.346,
    width: 22.6923,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 193.769,
    width: 32.9038,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 214.192,
    width: 36.3077,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 234.615,
    width: 45.3846,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 81.9414,
    y: 255.038,
    width: 36.3077,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 132.5,
    width: 76.0192,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 152.923,
    width: 56.7308,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 173.346,
    width: 72.6154,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 193.769,
    width: 64.6731,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 214.192,
    width: 47.6539,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 234.615,
    width: 70.3462,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 145.48,
    y: 255.038,
    width: 47.6539,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 132.5,
    width: 62.4039,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 152.923,
    width: 76.0192,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 173.346,
    width: 47.6539,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 193.769,
    width: 68.0769,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 214.192,
    width: 79.4231,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 234.615,
    width: 60.1346,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.059,
    y: 255.038,
    width: 79.4231,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 132.5,
    width: 79.4231,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 152.923,
    width: 56.7308,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 173.346,
    width: 72.6154,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 193.769,
    width: 61.2692,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 214.192,
    width: 73.75,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 234.615,
    width: 51.0577,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 340.637,
    y: 255.038,
    width: 61.2692,
    height: 6.80769,
    rx: 3.40385,
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_480_9133",
    x: 0.250605,
    y: 0.884619,
    width: 501.499,
    height: 363.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.53846,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_480_9133"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.4231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.0385
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_480_9133"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.80769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_480_9133"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3462
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_480_9133",
    result: "effect2_dropShadow_480_9133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_480_9133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_9133"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.7891,
    y: 44,
    width: 374.423,
    height: 236,
    rx: 9.07692,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockup);
export default __webpack_public_path__ + "static/media/mockup.ecec390704e4e9231abf476a1fe27a28.svg";
export { ForwardRef as ReactComponent };